"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _operation = require("@/api/operation");
var _channel = require("@/api/channel");
var _default = exports.default = {
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      times: [],
      channelList: [],
      listLoading: false,
      list: [],
      user_name: '',
      called: {},
      listQuery: {
        startTime: '',
        endTime: '',
        channelArr: ''
      }
    };
  },
  watch: {
    times: function times(val) {
      this.listQuery.startTime = '';
      this.listQuery.endTime = '';
      if (val) {
        this.listQuery.startTime = val[0];
        this.listQuery.endTime = val[1];
      }
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  created: function created() {
    this.getChannelCodeList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$distributorsDe, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              this.listQuery.channelArr = this.listQuery.channel.toString();
              _context.n = 1;
              return (0, _channel.distributorsDelayReportList)(this.listQuery);
            case 1:
              _yield$distributorsDe = _context.v;
              code = _yield$distributorsDe.code;
              data = _yield$distributorsDe.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data.list;
                this.user_name = data.user_name;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    getChannelCodeList: function () {
      var _getChannelCodeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _yield$channelCodeLis, code, data;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.listLoading = true;
              _context2.n = 1;
              return (0, _operation.channelCodeList)();
            case 1:
              _yield$channelCodeLis = _context2.v;
              code = _yield$channelCodeLis.code;
              data = _yield$channelCodeLis.data;
              this.listLoading = false;
              if (code === 0) {
                this.channelList = data;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getChannelCodeList() {
        return _getChannelCodeList.apply(this, arguments);
      }
      return getChannelCodeList;
    }(),
    handleFilter: function () {
      var _handleFilter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.listQuery.page = 1;
              this.list = [];
              this.getList();
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleFilter() {
        return _handleFilter.apply(this, arguments);
      }
      return handleFilter;
    }(),
    change: function change() {
      console.log(123);
      this.list = [];
    },
    channelDataExport: function channelDataExport() {
      if (!this.listQuery.startTime || !this.listQuery.endTime) {
        this.$message({
          message: '请选择导出时间',
          type: 'error'
        });
        return false;
      }
      window.open("/api/xls/channelAdminData/export?startTime=".concat(this.listQuery.startTime, "&endTime=").concat(this.listQuery.endTime, "&channelArr=").concat(this.listQuery.channelArr, "&user_name=").concat(this.user_name));
    }
  }
};